"use strict";

var _toConsumableArray = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lineForPosition_1 = require("./lineForPosition");

var types_1 = require("./types");

var utils_1 = require("./utils");

exports.getLocationForJsonPath = function (_ref, path) {
  var ast = _ref.ast,
      lineMap = _ref.lineMap,
      metadata = _ref.metadata;
  var closest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var node = findNodeAtPath(ast, path, {
    closest: closest,
    mergeKeys: metadata !== undefined && metadata.mergeKeys === true
  });
  if (node === void 0) return;
  return getLoc(lineMap, {
    start: getStartPosition(node, lineMap.length > 0 ? lineMap[0] : 0),
    end: getEndPosition(node)
  });
};

function getStartPosition(node, offset) {
  if (node.parent && node.parent.kind === types_1.Kind.MAPPING) {
    if (node.parent.value === null) {
      return node.parent.endPosition;
    }

    if (node.kind !== types_1.Kind.SCALAR) {
      return node.parent.key.endPosition + 1;
    }
  }

  if (node.parent === null && offset - node.startPosition === 0) {
    return 0;
  }

  return node.startPosition;
}

function getEndPosition(node) {
  switch (node.kind) {
    case types_1.Kind.SEQ:
      var items = node.items;

      if (items.length !== 0) {
        var lastItem = items[items.length - 1];

        if (lastItem !== null) {
          return getEndPosition(lastItem);
        }
      }

      break;

    case types_1.Kind.MAPPING:
      if (node.value !== null) {
        return getEndPosition(node.value);
      }

      break;

    case types_1.Kind.MAP:
      if (node.value !== null && node.mappings.length !== 0) {
        return getEndPosition(node.mappings[node.mappings.length - 1]);
      }

      break;

    case types_1.Kind.SCALAR:
      if (node.parent !== null && node.parent.kind === types_1.Kind.MAPPING && node.parent.value === null) {
        return node.parent.endPosition;
      }

      break;
  }

  return node.endPosition;
}

function findNodeAtPath(node, path, _ref2) {
  var closest = _ref2.closest,
      mergeKeys = _ref2.mergeKeys;

  var _iterator = _createForOfIteratorHelper(path),
      _step;

  try {
    pathLoop: for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var segment = _step.value;

      if (!utils_1.isObject(node)) {
        return closest ? node : void 0;
      }

      switch (node.kind) {
        case types_1.Kind.MAP:
          var mappings = getMappings(node.mappings, mergeKeys);

          for (var i = mappings.length - 1; i >= 0; i--) {
            var item = mappings[i];

            if (item.key.value === segment) {
              if (item.value === null) {
                node = item.key;
              } else {
                node = item.value;
              }

              continue pathLoop;
            }
          }

          return closest ? node : void 0;

        case types_1.Kind.SEQ:
          for (var _i = 0; _i < node.items.length; _i++) {
            if (_i === Number(segment)) {
              var _item = node.items[_i];

              if (_item === null) {
                break;
              }

              node = _item;
              continue pathLoop;
            }
          }

          return closest ? node : void 0;

        default:
          return closest ? node : void 0;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return node;
}

function getMappings(mappings, mergeKeys) {
  if (!mergeKeys) return mappings;
  return mappings.reduce(function (mergedMappings, mapping) {
    if (utils_1.isObject(mapping)) {
      if (mapping.key.value === "<<") {
        mergedMappings.push.apply(mergedMappings, _toConsumableArray(reduceMergeKeys(mapping.value)));
      } else {
        mergedMappings.push(mapping);
      }
    }

    return mergedMappings;
  }, []);
}

function reduceMergeKeys(node) {
  if (!utils_1.isObject(node)) return [];

  switch (node.kind) {
    case types_1.Kind.SEQ:
      return node.items.reduceRight(function (items, item) {
        items.push.apply(items, _toConsumableArray(reduceMergeKeys(item)));
        return items;
      }, []);

    case types_1.Kind.MAP:
      return node.mappings;

    case types_1.Kind.ANCHOR_REF:
      return reduceMergeKeys(node.value);

    default:
      return [];
  }
}

var getLoc = function getLoc(lineMap, _ref3) {
  var _ref3$start = _ref3.start,
      start = _ref3$start === void 0 ? 0 : _ref3$start,
      _ref3$end = _ref3.end,
      end = _ref3$end === void 0 ? 0 : _ref3$end;
  var startLine = lineForPosition_1.lineForPosition(start, lineMap);
  var endLine = lineForPosition_1.lineForPosition(end, lineMap);
  return {
    range: {
      start: {
        line: startLine,
        character: start - (startLine === 0 ? 0 : lineMap[startLine - 1])
      },
      end: {
        line: endLine,
        character: end - (endLine === 0 ? 0 : lineMap[endLine - 1])
      }
    }
  };
};